import React from 'react';
import { Box, Typography, Button } from '@mui/material';

interface TourSlot {
  id: string;
  date: string;
  start_time_local: string;
  end_time_local: string;
  available_spots: number;
  has_pending_request?: boolean;
}

interface TourSlotsDisplayProps {
  slots: TourSlot[];
  selectedSlotId: string | null;
  onSelectSlot: (slot: TourSlot) => void;
  formatDate: (dateString: string) => string;
  formatTime: (timeString: string) => string;
}

const TourSlotsDisplay: React.FC<TourSlotsDisplayProps> = ({
  slots,
  selectedSlotId,
  onSelectSlot,
  formatDate,
  formatTime,
}) => {
  let lastDate = '';
  return (
    <Box sx={{ width: '100%', maxWidth: '600px' }}>
      {slots.length === 0 ? (
        <Typography variant="body1" sx={{ textAlign: 'center', mt: 4 }}>
          No more tour slots available.
        </Typography>
      ) : (
        slots.map((slot, idx) => {
          const showDateHeader = slot.date !== lastDate;
          lastDate = slot.date;
          const isTaken = slot.has_pending_request === true;
          const isSelected = selectedSlotId === slot.id;
          
          return (
            <React.Fragment key={slot.id}>
              {showDateHeader && (
                <Typography variant="h6" sx={{ mt: idx === 0 ? 0 : 3, mb: 1 }}>
                  {formatDate(slot.date)}
                </Typography>
              )}
              <Button
                variant={isSelected ? 'contained' : 'outlined'}
                onClick={() => !isTaken && onSelectSlot(slot)}
                disabled={isTaken}
                sx={{
                  width: '90%',
                  margin: '0.5rem 0',
                  padding: '1rem',
                  textTransform: 'none',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  backgroundColor: isTaken ? '#F5F5F5' : (isSelected ? '#F5F5F5' : 'transparent'),
                  color: isTaken ? '#9E9E9E' : '#000',
                  border: '2px solid #E5E5E5',
                  boxShadow: 'none',
                  borderColor: isTaken ? '#E5E5E5' : (isSelected ? '#000' : '#E5E5E5'),
                  '&:hover': {
                    borderColor: isTaken ? '#E5E5E5' : '#000',
                    backgroundColor: isTaken ? '#F5F5F5' : (isSelected ? '#F5F5F5' : 'transparent'),
                    color: isTaken ? '#9E9E9E' : '#000',
                    boxShadow: 'none',
                  },
                  '&.Mui-disabled': {
                    backgroundColor: '#F5F5F5',
                    color: '#9E9E9E',
                    border: '2px solid #E5E5E5',
                  },
                }}
              >
                <span>{formatTime(slot.start_time_local)}</span>
                {isTaken && (
                  <Typography
                    component="span"
                    sx={{
                      fontSize: '0.75rem',
                      color: '#9E9E9E',
                      mt: 0.5,
                    }}
                  >
                    Taken
                  </Typography>
                )}
              </Button>
            </React.Fragment>
          );
        })
      )}
    </Box>
  );
};

export default TourSlotsDisplay;